export default __webpack_public_path__ + "static/media/imgLightEn5.4827cbab.png";